import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CssLayersInput from './CssLayersInput';
import ClientProvider from './client';
export default createDemo(import.meta.url, CssLayersInput, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/css-layers/demos/input/CssLayersInput.tsx",
    "fileName": "CssLayersInput.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport FormControl from '@mui/material/FormControl';\nimport InputLabel from '@mui/material/InputLabel';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nconst theme = createTheme({\n  modularCssLayers: true,\n  cssVariables: true,\n});\n\nexport default function CssLayersInput() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <FormControl variant=\"outlined\">\n        <InputLabel\n          shrink\n          htmlFor=\"css-layers-input\"\n          sx={{\n            width: 'fit-content',\n            transform: 'none',\n            position: 'relative',\n            mb: 0.25,\n            fontWeight: 'medium',\n            pointerEvents: 'auto',\n          }}\n        >\n          Label\n        </InputLabel>\n        <OutlinedInput\n          id=\"css-layers-input\"\n          placeholder=\"Type something\"\n          slotProps={{\n            input: {\n              sx: { py: 1.5, height: '2.5rem', boxSizing: 'border-box' },\n            },\n          }}\n        />\n        <FormHelperText sx={{ marginLeft: 0 }}>Helper text goes here</FormHelperText>\n      </FormControl>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 43,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport FormControl from '@mui/material/FormControl';\nimport InputLabel from '@mui/material/InputLabel';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nconst theme = createTheme({\n  modularCssLayers: true,\n  cssVariables: true,\n});\n\nexport default function CssLayersInput() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <FormControl variant=\"outlined\">\n        <InputLabel\n          shrink\n          htmlFor=\"css-layers-input\"\n          sx={{\n            width: 'fit-content',\n            transform: 'none',\n            position: 'relative',\n            mb: 0.25,\n            fontWeight: 'medium',\n            pointerEvents: 'auto',\n          }}\n        >\n          Label\n        </InputLabel>\n        <OutlinedInput\n          id=\"css-layers-input\"\n          placeholder=\"Type something\"\n          slotProps={{\n            input: {\n              sx: { py: 1.5, height: '2.5rem', boxSizing: 'border-box' },\n            },\n          }}\n        />\n        <FormHelperText sx={{ marginLeft: 0 }}>Helper text goes here</FormHelperText>\n      </FormControl>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 43,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/FormControl",
      "@mui/material/InputLabel",
      "@mui/material/OutlinedInput",
      "@mui/material/FormHelperText"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
